import React from 'react';

export const highlightText = (text, query) => {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, i) =>
        regex.test(part) ? <mark key={i} className="bg-yellow-200">{part}</mark> : part
    );
};

export const formatCondition = (condition, query) => {
    const rows = [];

    const attrs = Array.from(condition.attributes || []);
    attrs.forEach((attr, index) => {
        rows.push(
            <tr key={`attr-${index}`}>
                <td className="w-1">
                    <span className="badge badge-outline text-indigo">{attr.name}</span>
                </td>
                <td>{highlightText(attr.value, query)}</td>
            </tr>
        );
    });

    if (condition.tagName === 'FileHashCondition') {
        const fileHash = condition.getElementsByTagName('FileHash')[0];
        if (fileHash) {
            const hashAttrs = Array.from(fileHash.attributes || []);
            hashAttrs.forEach((attr, index) => {
                rows.push(
                    <tr key={`hash-${index}`}>
                        <td className="w-1">
                            <span className="badge badge-outline text-indigo">{attr.name}</span>
                        </td>
                        <td>{highlightText(attr.value, query)}</td>
                    </tr>
                );
            });
        }
    }

    const binaryVersionRange = condition.getElementsByTagName('BinaryVersionRange')[0];
    if (binaryVersionRange) {
        let low = binaryVersionRange.getAttribute('LowSection') || '-';
        let high = binaryVersionRange.getAttribute('HighSection') || '-';

        if (low === '*') low = 'any';
        if (high === '*') high = 'any';

        rows.push(
            <tr key="binary-range">
                <td className="w-1">
                    <span className="badge badge-outline text-indigo">Binary Version Range</span>
                </td>
                <td>
                    <span className="badge bg-green-lt text-green me-2">Low</span> {highlightText(low, query)}
                    <span className="ms-3 me-2"></span>
                    <span className="badge bg-red-lt text-red me-2">High</span> {highlightText(high, query)}
                </td>
            </tr>
        );
    }

    return (
        <table className="table table-vcenter card-table">
            <tbody>{rows}</tbody>
        </table>
    );
};